import TopNavigationComponent from '../../components/stories/organisms/top-navigation/index.jsx'
import { LogoComponent } from '../../components/stories/organisms/top-navigation/components/logo.jsx'

import ProjectSelect from './components/quick-select/project-select.jsx'
import { TopBarNavigationWrapper } from './styled-components.js'
import PlanSelect from './components/quick-select/plan-select.jsx'
import { SearchBar } from './components/search/index.jsx'
import UtilityIcons from './components/utility-icons/index.jsx'
import Support from './components/utility-icons/support/index.jsx'
import Notifications from './components/utility-icons/notifications/index.jsx'
import Settings from './components/utility-icons/settings/index.jsx'
import Users from './components/utility-icons/users/index.jsx'

const TopBarNavigation = () => {
  return (
    <TopBarNavigationWrapper>
      <TopNavigationComponent
        leftItems={[
          <LogoComponent key="logo" />,
          <ProjectSelect key="project-quick-select" />,
          <PlanSelect key="plan-quick-select" />
        ]}
        rightItems={[
          <SearchBar key="global-search" />,
          <UtilityIcons key="utility-icons">
            <Support />
            <Notifications />
            <Settings />
            <Users />
          </UtilityIcons>
        ]}
      />
    </TopBarNavigationWrapper>
  )
}

TopBarNavigation.propTypes = {}

export default TopBarNavigation
